import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';
import TextEllipsis from '@/components/comments/TextEllipsis';
import previewer from 'vue-photoswipe-mobile';
import { convertToThumb } from '@/utils/image';
import Drip from 'drip';
import { pageTo } from '@/utils/comment';
import STAR_NONE from '@/assets/comments/list_star-grey@3x.png';
import STAR_HALF from '@/assets/comments/list_star-half@3x.png';
import STAR_ALL from '@/assets/comments/list_star-light@3x.png';
import { dateFormat } from '@/utils';
import VipLevel from '@/components/vip/vip-level';
export default {
  name: 'comment-item',
  props: {
    commentType: {
      // 评论组件展示样式, 1代表全部评论列表，2代表在项目详情页列表，3代表评论详情
      type: Number,
      default: 1
    },
    commentData: {
      // 评论数据
      type: Object,
      default: function _default() {
        return {};
      }
    },
    noShowTopWarn: {
      // 详情页不展示顶部提示
      type: Boolean,
      default: false
    },
    isShowBottomBorder: {
      // 是否是最后一个
      type: Boolean,
      default: false
    }
  },
  components: {
    TextEllipsis: TextEllipsis,
    VipLevel: VipLevel
  },
  mounted: function mounted() {},
  data: function data() {
    return {};
  },
  computed: {
    isMoreImages: function isMoreImages() {
      // 是否有超出的图片未显示
      if (this.commentType === 1 && this.list.length > 9 || this.commentType === 2 && this.list.length > 3) {
        return true;
      }
      return false;
    },
    stars: function stars() {
      // 星星列表
      var stars = [];
      if (this.commentData && this.commentData.score) {
        switch (this.commentData.score) {
          case 1:
            stars = [STAR_HALF];
            break;
          case 2:
            stars = [STAR_ALL];
            break;
          case 3:
            stars = [STAR_ALL, STAR_HALF];
            break;
          case 4:
            stars = [STAR_ALL, STAR_ALL];
            break;
          case 5:
            stars = [STAR_ALL, STAR_ALL, STAR_HALF];
            break;
          case 6:
            stars = [STAR_ALL, STAR_ALL, STAR_ALL];
            break;
          case 7:
            stars = [STAR_ALL, STAR_ALL, STAR_ALL, STAR_HALF];
            break;
          case 8:
            stars = [STAR_ALL, STAR_ALL, STAR_ALL, STAR_ALL];
            break;
          case 9:
            stars = [STAR_ALL, STAR_ALL, STAR_ALL, STAR_ALL, STAR_HALF];
            break;
          case 10:
            stars = [STAR_ALL, STAR_ALL, STAR_ALL, STAR_ALL, STAR_ALL];
            break;
          default:
            break;
        }
      }
      while (stars.length < 5) {
        stars.push(STAR_NONE);
      }
      return stars;
    },
    list: function list() {
      // 图片列表
      if (this.commentData && this.commentData.images) {
        return this.commentData.images.map(function (item) {
          return {
            type: 'image',
            src: item.mediaUrl
          };
        });
      }
      return [];
    },
    info: function info() {
      var _ref = this.commentData || {},
        updateTime = _ref.updateTime,
        commentCity = _ref.commentCity;
      var time = updateTime && dateFormat(updateTime, 'yyyy.MM.dd') || null;
      return "".concat(time || '', "  ").concat(commentCity || '');
    }
  },
  methods: {
    convertToThumb: convertToThumb,
    getImgStyle: function getImgStyle(url) {
      return {
        background: "url(".concat(url, ") no-repeat"),
        backgroundPosition: 'center'
      };
    },
    toCommentDetail: function toCommentDetail() {
      // 如果是详情页的地址则阻止跳转
      if (/^\/comments\/detail/i.test(this.$route.path)) return;
      var url = "/comments/detail/".concat(this.commentData.commentId);
      if (this.noShowTopWarn) {
        url += '?noTopWarn=1';
      }
      // 点击评论详情打点
      var _this$commentData = this.commentData,
        performance_id = _this$commentData.projectId,
        commentId = _this$commentData.commentId;
      this.$emit('statsHandler', 'commentClick', {
        performance_id: performance_id,
        city_id: Drip.constant.cityId,
        commentId: commentId
      });
      pageTo(url);
    },
    preview: function preview(index) {
      // 预览图片点击打点
      this.$emit('statsHandler', 'commentImgClick');
      previewer.open(index, this.list, {
        loadingIndicatorDelay: 0,
        errorMsg: '<div class="pswp__error-msg" style="text-align: center;"><div style="width: 100vw;">图片加载失败</div></div>'
      });
    }
  }
};